"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.correctEffectOfRefraction = exports.correctEffectOfAberration = exports.correctEffectOfNutation = exports.getLightTimeCorrectedJulianDay = void 0;
var earthCalc_1 = require("../../earth/calculations/earthCalc");
var calculations_1 = require("../../sun/calculations");
var angleCalc_1 = require("../../utils/angleCalc");
function getLightTimeCorrectedJulianDay(jd, d) {
    var theta = 0.0057755183 * d;
    return jd - theta;
}
exports.getLightTimeCorrectedJulianDay = getLightTimeCorrectedJulianDay;
function correctEffectOfNutation(coords, T) {
    var phi = (0, earthCalc_1.getNutationInLongitude)(T);
    return {
        lon: coords.lon + phi,
        lat: coords.lat,
        radiusVector: coords.radiusVector,
    };
}
exports.correctEffectOfNutation = correctEffectOfNutation;
function correctEffectOfAberration(coords, T) {
    var lonSun = calculations_1.sunCalc.getTrueLongitude(T);
    var e = (0, earthCalc_1.getEccentricity)(T);
    var pi = (0, earthCalc_1.getLongitudeOfPerihelionOfOrbit)(T);
    var k = (0, angleCalc_1.sec2deg)(20.49552);
    var lonRad = (0, angleCalc_1.deg2rad)(coords.lon);
    var latRad = (0, angleCalc_1.deg2rad)(coords.lat);
    var lonSunRad = (0, angleCalc_1.deg2rad)(lonSun);
    var piRad = (0, angleCalc_1.deg2rad)(pi);
    var dLon = (-1 * k * Math.cos(lonSunRad - lonRad) + e * k * Math.cos(piRad - lonRad)) / Math.cos(latRad);
    var dLat = -1 * k * Math.sin(latRad) * (Math.sin(lonSunRad - lonRad) - e * Math.sin(piRad - lonRad));
    return {
        lon: coords.lon + dLon,
        lat: coords.lat + dLat,
        radiusVector: coords.radiusVector,
    };
}
exports.correctEffectOfAberration = correctEffectOfAberration;
function correctEffectOfRefraction(altitude) {
    if (altitude < -5) {
        return altitude;
    }
    var R = 1.02 / Math.tan((0, angleCalc_1.deg2rad)(altitude + 10.3 / (altitude + 5.11)));
    return altitude + R / 60;
}
exports.correctEffectOfRefraction = correctEffectOfRefraction;
